import request from '@/utils/request'

const END_POINT = '/dbservice/api/v1/watchlist'
const api = {}

api.addToWatchList = (watchList) => request.post(`${END_POINT}/${watchList.customerid}`, watchList)
api.getWatchList = (customerid) => request.get(`${END_POINT}/${customerid}`)

export default api
